<template>
  <div id="EnterPhone">
    <div class="login-page">
      <transition name="fade">
        <div v-if="!registerActive" class="wallpaper-login"></div>
      </transition>
      <div class="wallpaper-register"></div>

      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-8 mx-auto">
            <div
              id="login-card"
              v-if="!registerActive"
              class="card login"
              v-bind:class="{ error: emptyFields }"
            >
              <h3>กรอกรหัส OTP</h3>
              <h6 style="color:red;">{{ sendotp_message }}</h6>
              <form class="form-group" @submit.prevent="sendotp">
                <input
                  v-model="otp_code"
                  type="text"
                  class="form-control input-style"
                  placeholder="กรุณากรอกรหัส OTP ที่ได้รับจาก email"
                  required
                />
                <button
                  :disabled="!isComplete"
                  id="button"
                  type="submit"
                  class="btn btn-purple deep-purple btn-block "
                  data-toggle="modal"
                  data-target="#exampleModalCenter"
                >
                  ยืนยัน
                </button>
                <!--  -->
                <div
                  class="modal fade"
                  id="exampleModalCenter"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalCenterTitle"
                  aria-hidden="true"
                  v-if="chk"
                >
                  <div
                    class="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div class="modal-content text-left">
                      <div class="modal-body" v-if="sendotp_message">
                        <h5>{{ sendotp_message }}</h5>
                      </div>
                      <div class="modal-body" v-if="!sendotp_message">
                        <h4>ข้อมูลใช้ในการเข้าสู่ระบบ</h4>
                        <p>
                          รหัสผู้ใช้ :
                          <strong class="text-success">{{ std_code }}</strong>
                        </p>

                        <p>
                          รหัสผ่าน :
                          <strong class="text-danger">4 ตัวท้าย</strong>
                          หมายเลขโทรศัพท์
                        </p>
                      </div>
                      <div class="modal-footer" v-if="loginModal">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          data-dismiss="modal"
                          v-if="!loginModal"
                        >
                          Close
                        </button>
                        <router-link
                          to="/"
                          class="btn btn-outline-info"
                          data-dismiss="modal"
                        >
                          รับทราบ</router-link
                        >

                      </div>
                    </div>
                  </div>
                </div>

                <!--  -->
                <!-- <p>
                  ขอรหัส OTP
                  <a
                    href="#"
                    @click="
                      (registerActive = !registerActive), (emptyFields = false)
                    "
                    style="color:#f9476c"
                    >อีกครั้ง</a
                  >
                </p> -->
              </form>
            </div>

            <div
              id="regis-card"
              v-else
              class="card register"
              v-bind:class="{ error: emptyFields }"
            >
              <h3>ขอรหัส OTP อีกครั้ง</h3>
              <h6 style="color:red;">{{ sendphone_again }}</h6>
              <form class="form-group" @submit.prevent="sendphone">
                <input
                  v-model="phone_number"
                  type="text"
                  class="form-control input-style"
                  placeholder="กรุณากรอกเบอร์โทรศัพท์"
                  required
                />

                <button
                  id="button"
                  type="submit"
                  class="btn btn-purple deep-purple btn-block"
                >
                  ยืนยัน
                </button>
                <p>
                  <a
                    href="#"
                    @click="
                      (registerActive = !registerActive), (emptyFields = false)
                    "
                    style="color:#f9476c;"
                    >กรอกรหัส OTP</a
                  >
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="alert hide">
      <span class="fas fa-exclamation-circle"></span>
      <span class="msg">{{ sendotp_message }} {{ sendphone_again }}</span>
      <div class="close-btn">
        <span class="fas fa-times"></span>
      </div>
    </div> -->
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "EnterPhone",
  data() {
    return {
      otp_code: "",
      phone_number: "",
      registerActive: false,
      emptyFields: false,
      secret_one: "",
      sendotp_message: "",
      sendphone_again: "",
      loginModal: false,
      staff: false,
      std_code: "",
      chk:false
    };
  },
  computed: {
    isComplete() {
      return this.otp_code;
    },
  },
  methods: {
    sendotp() {
      let otp = this.otp_code;
      this.$isLoading(true);
      this.$store
        .dispatch("verify", { otp })
        .then((res) => {
          // console.log(res);
          // console.log(typeof res);
          if (res.msg.status !== 200) {
            
            this.$isLoading(false);
            this.chk = false;
            this.sendotp_message = res.msg.message;
            localStorage.setItem("login", false);
            this.loginModal = JSON.parse(localStorage.getItem("login"));
            // console.log(this.loginModal);
          } else {
            this.$isLoading(false);
            this.$router.push("/profile");
            this.chk = true;
            localStorage.setItem("login", true);
            this.loginModal = JSON.parse(localStorage.getItem("login"));
            // console.log(this.loginModal);
            this.std_code = JSON.parse(localStorage.getItem("std_code"));
          }
        })

        .catch((err) => console.log(err));
    },
    sendphone() {
      let phone = this.phone_number;
      this.$isLoading(true);
      this.$store.dispatch("send_phone", { phone }).then((res) => {
        if (res.msg.status !== 200) {
          this.$isLoading(false);
          this.sendphone_again = res.msg.message;
          this.registerActive = true;
        } else {
          this.$isLoading(false);
          this.registerActive = false;
        }
      });
      this.$isLoading(false).catch((err) => console.log(err));
    },
  },
  mounted() {
    $("button").click(function() {
      $(".alert").addClass("show");
      $(".alert").removeClass("hide");
      $(".alert").addClass("showAlert");
      setTimeout(function() {
        $(".alert").removeClass("show");
        $(".alert").addClass("hide");
      }, 5000);
    });
    $(".close-btn").click(function() {
      $(".alert").removeClass("show");
      $(".alert").addClass("hide");
    });
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");

#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #ebf0fc;
  border-color: #ebf0fc;
  color: #9da3b0;
}
#login-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}
#regis-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}

p {
  line-height: 1rem;
}

.card {
  padding: 20px;
}

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}

.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
.login-page .wallpaper-login {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background: -webkit-linear-gradient(-55deg, #ff77a0 40%, #ce40ea 100%)
    no-repeat center center;
    /* background: -webkit-linear-gradient(-55deg, #ff4e50 40%, #f9d423 100%)
    no-repeat center center;  */
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}

.login-page .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.wallpaper-register {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background-size: cover;
  background: -webkit-linear-gradient(-55deg, #ce40ea  40%, #ff77a0 100%)
    no-repeat center center;
    /* background: -webkit-linear-gradient(-55deg, #f9d423 40%, #ff4e50 100%)
    no-repeat center center;  */
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
}

h1 {
  margin-bottom: 1.5rem;
  font-family: "Kanit", sans-serif;
  font-weight: bold;
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}

.btn-purple{
    color: #fff;
    border-color: #ec376a; 
    background-color: #ec376a;
}

.btn-purple:hover
{
    color: #fff;
    border-color: #f7618c; 
    background-color: #ce2b59;
}
.btn-purple:focus,
.btn-purple.focus
{
    color: #fff;
    border-color: #f7618c;
    background-color: #ce2b59;
    box-shadow: 0 0 0 .2rem rgba(180, 72, 112, 0.5);
}
.btn-purple.disabled,
.btn-purple:disabled
{
    color: #fff;
    border-color: #ec376a;
    background-color: #ec376a;
}
.btn-purple:not(:disabled):not(.disabled):active,
.btn-purple:not(:disabled):not(.disabled).active,
.show > .btn-purple.dropdown-toggle
{
    color: #fff;
    border-color: #ec376a; 
    background-color: #f7618c;
}
.btn-purple:not(:disabled):not(.disabled):active:focus,
.btn-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-purple.dropdown-toggle:focus
{
    box-shadow: 0 0 0 .2rem rgba(180, 72, 112, 0.5);
}
</style>
